import React, {useState, useEffect} from 'react'
import moment from 'moment'
import {observer, inject} from 'mobx-react'
import Button from '@components/button'
import './header.less'

const OvervierHeader = inject('store')(
  observer(({store, history}) => {
    const {userInfo, queryUserInfo, userLogout} = store
    const [curTime, setCurTime] = useState(new Date())
    const [curWeather, setCurWeather] = useState({})
    const [curCity, setCurCity] = useState()
    const {
      pathname,
    } = location

    async function init() {
      try {
        await queryUserInfo()
      } finally {
      }
    }

    // 定时轮询当前时间
    function intervalTime() {
      setInterval(() => {
        setCurTime(new Date())
      }, 1000)
    }

    //查询现在所在位置城市
    function showCityInfo() { 
      //加载城市查询插件 
      AMap.service(["AMap.CitySearch"], function() { 
        //实例化城市查询类 
        var citysearch = new AMap.CitySearch(); 
        //自动获取用户IP，返回当前城市 
        citysearch.getLocalCity(function(status, result){ 
          if(status === 'complete' && result.info === 'OK'){ 
            if(result && result.city && result.bounds) {
              setCurCity(result.city)
            } 
          }else{ 
            console.log("您当前所在城市：" + result.info + ""); 
          } 
        }); 
      }); 
    }

    //查询当前位置城市天气信息
    function getWeather() {
      AMap.plugin('AMap.Weather', function() {
        //创建天气查询实例
        var weather = new AMap.Weather();
    
        //执行实时天气信息查询
        weather.getLive(curCity, function(err, data) {
          console.log(err, data);
          setCurWeather(data)
        });
      });
    }

    useEffect(() => {
      showCityInfo()
      intervalTime()
      getWeather()
      init()
    }, [curCity])

    return (
      <div className="overview-header">
        <span className="header-sp">
          {moment(curTime).format('YYYY.MM.DD HH:mm:ss')}
        </span>
        <span className="shugang-sp">|</span>
        <span className="header-sp">
          {curWeather.weather || '--'} 
          {curWeather.temperature || '--'}℃
        </span>
        <span className="shugang-sp">|</span>
        <span className="header-sp">
          中国 {curCity ? curCity.replace("市", "") : '--'}
        </span>
        <span className="shugang-sp">|</span>
        {
          userInfo ? (
            <span className="header-sp header-username">
              {userInfo.userName}
              <Button
                className="login-out"
                onClick={() => {
                  userLogout()
                  history.push('/login')
                }}
              >
                退出登录
              </Button>
            </span>
          ) : (
            <span
              className="header-sp header-username"
              onClick={() => {
                history.push('/login')
              }}
            >
              登录
            </span>
          )
        }
      </div>
    )
  })
)

export default OvervierHeader
